import { gql } from '@apollo/client'

// Get all explore items with filters - now supports both list and single item retrieval
export const GET_EXPLORE_ITEMS = gql`
    query GetExploreItems($countryCode: CountryCode, $page: PageInput, $searchString: String, $itemId: String, $categoryCode: String) {
        getExploreItems(country_code: $countryCode, page: $page, searchString: $searchString, item_id: $itemId, category_code: $categoryCode) {
            code
            success
            message
            total_count
            explore_item {
                item_id
                country_code
                category_code
                content {
                    title {
                        en
                        ar
                    }
                    cover_image {
                        mobile {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                        tablet {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    images {
                        mobile {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                        tablet {
                            file_name
                            size
                            mime_type
                            s3_key
                        }
                    }
                    link_url
                    contact_no
                    pricing {
                        price_from
                        currency
                    }
                    description {
                        en
                        ar
                    }
                    location {
                        city
                        lat
                        lng
                    }
                }
                valid_from
                valid_to
                is_active
                user_audit
            }
        }
    }
`
